import { api } from "@api/api";
import { masks } from "@core/utils/masks";
import { Agreement } from "@modules/agreements/types/agreement";
import { normalizeVolumetryAgreementFields } from "@modules/agreements/utils/normalizeVolumetryAgreementFields";
import { AgreementFormValues } from "@modules/agreements/validations/agreementSchema";

export async function editAgreementService(
  id: string,
  data: Partial<AgreementFormValues>
): Promise<Agreement> {
  const { logo, referral_image, ...body } = data;
  normalizeVolumetryAgreementFields(body);

  // Normalizar valores numéricos que vêm com máscara
  if (body.value) {
    const unmaskedValue = Number(masks.unmask(body.value as any));
    (body as any).value = (unmaskedValue / 100).toFixed(2);
  }

  if (body.referral_value) {
    const unmaskedReferralValue = Number(
      masks.unmask(body.referral_value as any)
    );
    (body as any).referral_value = (unmaskedReferralValue / 100).toFixed(2);
  }

  const { data: agreement } = await api.patch<Agreement>(
    `v1/agreement_admin/${id}/`,
    body
  );

  // Atualizar arquivos (logo e imagem de indicação) via multipart/form-data
  if ((logo && logo instanceof File) || (referral_image && referral_image instanceof File)) {
    const formData = new FormData();

    if (logo && logo instanceof File) {
      formData.append("logo", logo);
    }

    if (referral_image && referral_image instanceof File) {
      formData.append("referral_image", referral_image);
    }

    const { data: agreementWithFiles } = await api.patch<Agreement>(
      `v1/agreement_admin/${id}/`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return agreementWithFiles;
  }

  return agreement;
}
